<template>
    <div>
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
                <li @click="active_tab = 'questions'" class="tab-green active"><a href="#questions" data-toggle="tab">{{ _t('Questions') }}</a></li>
                <li @click="active_tab = 'rules'" class="tab-green"><a href="#rules" data-toggle="tab">{{ _t('Rules') }}</a></li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="questions" style="padding-top: 10px;">
                    <Questions
                        v-if="active_tab === 'questions'"
                        :store-questions-route="storeQuestionsRoute"
                        :routine-options="routineOptions"
                        :survey-id="surveyId"
                        :is-active="isSurveyActive"
                    />
                </div>
                <div class="tab-pane" id="rules" style="padding-top: 10px;">
                    <Rules
                        v-if="active_tab === 'rules'"
                        :survey_id="surveyId"
                        :routine-options="routineOptions"
                        :store-rules-route="storeRulesRoute"
                        :index-questions-route="indexQuestionsRoute"
                        :is-active="isSurveyActive"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Questions from "./Questions";
import Rules from "./Rules";

export default {
    name: "SurveyQuestionRulesWrapper",
    components: {Rules, Questions},
    props: {
        surveyId: {
            type: Number,
            required: true
        },
        routineOptions: {
            type: Object,
            required: true
        },
        storeQuestionsRoute: {
            type: String,
            required: true,
        },
        storeRulesRoute: {
            type: String,
            required: true,
        },
        questions: {
            type: Array,
            required: true
        },
        rules: {
            type: Array,
            required: true
        },
        indexQuestionsRoute: {
            type: String,
            required: true,
        },
        isActive: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            active_tab: 'questions'
        }
    },
    computed: {
        isSurveyActive() {
            return this.isActive === 1;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/SurveyQuestionRulesWrapper.vue